import objUtils from 'utils/objUtils';
import mainAPI from 'api/MainAPI';
import cloneDeep from 'lodash.clonedeep';
import utils from '../utils/utils';
import models from './models';

export default class GeneralModel {
	constructor(modelName, socket, allEndpoint, saveLocalKey) {
		this.model = modelName;
		this.allEndpoint = allEndpoint;
		this.socket = socket;
		this.saveLocalKey = saveLocalKey;
		this.Objects = {};
		if (saveLocalKey) this.Objects = utils.parseJSON(localStorage[saveLocalKey]) || {};
		this.ChangeHandlers = {};
		this.SingleChangeHandlers = {};
		this.CurrentChangeHandlers = {};
		this.CurrentObjId = null;
		setTimeout(() => {
			this.refreshData().then();
		}, 500);
		this.LastSubscribeId = Date.now();
		this.tempObj = {};
	}

	onChange = (callback) => {
		let id = this.LastSubscribeId++;
		this.ChangeHandlers[id] = callback;
		if (!objUtils.is_empty(this.Objects)) {
			this.ChangeHandlers[id](cloneDeep(this.Objects));
		}
		return parseInt(id, 10);
	};

	onSingleChange = (id, callback) => {
		let sub_id = this.LastSubscribeId++;
		if (!this.SingleChangeHandlers[id]) this.SingleChangeHandlers[id] = {};
		this.SingleChangeHandlers[id][sub_id] = callback;
		if (this.Objects[id]) {
			this.SingleChangeHandlers[id][sub_id](cloneDeep(this.Objects[id]));
		}
		return parseInt(sub_id, 10);
	};

	onCurrentChange = (callback) => {
		let id = this.LastSubscribeId++;
		this.CurrentChangeHandlers[id] = callback;
		if (!objUtils.is_empty(this.Objects)) {
			this.CurrentChangeHandlers[id](this.getCurrent());
		}
		return parseInt(id, 10);
	};

	unsubscribe = (id) => {
		if (this.ChangeHandlers[id]) {
			delete this.ChangeHandlers[id];
		} else if (this.CurrentChangeHandlers[id]) {
			delete this.CurrentChangeHandlers[id];
		} else {
			for (let i in this.SingleChangeHandlers) {
				for (let j in this.SingleChangeHandlers[i]) {
					if (j === id) {
						delete this.SingleChangeHandlers[i][j];
					}
				}
			}
		}
	};

	save = async (obj, localOnly) => {
		obj = utils.client_to_server_obj(obj, this.model);
		if (localOnly) {
			this.Objects[obj.id] = obj;
			this._FireChanged(obj.id);
			return cloneDeep(obj);
		} else if (!obj.id) {
			let res = await mainAPI[this.model].create(obj);
			if (!res) return;
			this.Objects[res.id] = res;
			this._GetData();
			this._FireChanged(res.id);
			return cloneDeep(res);
		} else {
			delete obj.created_on;
			let res = await mainAPI[this.model].update(obj);
			if (!res) return;
			this.Objects[obj.id] = res;
			this._FireChanged(obj.id);
			return cloneDeep(res);
		}
	};

	delete = async (obj_id, notes) => {
		delete this.Objects[obj_id];
		let deleteSuccess = await mainAPI[this.model].delete({ id: obj_id, notes }, function() {});
		this._FireChanged(obj_id);
		if (deleteSuccess) {
			return deleteSuccess;
		}
	};

	async archive(id, notes) {
		let response = await mainAPI[this.model].archiveReturnError({id: id, notes});
		const {err: {response: {data: {err}}} = {response: {data: {}}}} = response;
		if (err === 'UNRESOLVED_DEPENDENCY') {
			return {id, archived: false, reason: 'UNRESOLVED_DEPENDENCY'};
		} else {
			this.Objects[id].archived_on = new Date();
			this._FireChanged(id);
			return {id, archived: true};
		}
	};

	isArchived = ({archived_on} = {archived_on: null}) => (archived_on instanceof Date && archived_on != 'Invalid Date')

	obj = (obj_id) => {
		return cloneDeep(this.Objects[obj_id]);
	};

	objs = () => {
		return cloneDeep(this.Objects);
	};

	search = (search, field) => {
		return objUtils.search(this.Objects, field, search);
	};

	getCurrent = () => {
		return this.Objects[this.CurrentObjId];
	};

	setCurrent = (obj) => {
		this.CurrentObjId = obj.id;
		this.Objects[obj.id] = obj;
		for (var i in this.CurrentChangeHandlers) {
			this.CurrentChangeHandlers[i](cloneDeep(obj));
		}
	};

	refreshData = async () => {
		this._subscribeSockets();
		await this._GetData();
	};

	_subscribeSockets = () => {
		if (!this.socket) return;
		if (this.socketSubscribeId) this.socket.off(this.socketSubscribeId);
		let user = models.user.getCurrent();
		if (!user) return;
		this.socketSubscribeId = this.socket.on(user.user_group_id, this._dataChanged);
	};

	_dataChanged = async (message) => {
		message = JSON.parse(message);
		let ids = message.data;
		let objs = [];
		for (let i in ids) {
			let item = await mainAPI[this.model].get(ids[i]);
			if (!item) continue;
			objs.push(item);
		}
		objs = objUtils.to_obj(objs, 'id');
		this._update(objs);
	};

	_update = (objs) => {
		for (let i in objs) {
			this.Objects[i] = objs[i];
		}
		this._FireChanged();
	};

	_GetData = async () => {
		let allEndpoint = mainAPI[this.model].all;
		if (this.allEndpoint) {
			allEndpoint = this.allEndpoint;
		}
		let objects = await allEndpoint();
		this.Objects = objUtils.to_obj(objects, 'id');
		if (this.saveLocalKey) localStorage[this.saveLocalKey] = JSON.stringify(this.Objects);
		this._FireChanged();
	};

	_FireChanged = (optionalId) => {
		for (var i in this.ChangeHandlers) {
			this.ChangeHandlers[i](cloneDeep(this.Objects));
		}
		if (optionalId) {
			for (let i in this.SingleChangeHandlers[optionalId]) {
				this.SingleChangeHandlers[optionalId][i](this.Objects[optionalId]);
			}
		}
	};

	tempCache = (obj) => {
		if (obj) {
			for (let i in obj) {
				this.tempObj[i] = obj[i];
			}
		}
		return cloneDeep(this.tempObj);
	};
}



// WEBPACK FOOTER //
// ./src/model/GeneralModel.js